// TODO: CategoryModel with surplus getter

export class CategoryModel {
  id: string;
  group?: string;
  name: string;
  necessary: boolean;
  budgeted: number;
  spent: number;
  savings: boolean;

  constructor(data: Omit<CategoryModel, "surplus">) {
    this.id = data.id ?? `${data.name}-${Date.now()}`;
    this.group = data.group;
    this.name = data.name;
    this.necessary = data.necessary;
    this.budgeted = data.budgeted;
    this.spent = data.spent;
    this.savings = data.savings ?? false;
  }

  /** Surplus when budgeted exceeds spent */
  get surplus(): boolean {
    return this.budgeted > this.spent;
  }
}
